// extracted by mini-css-extract-plugin
export default {"notification-card":"RSVP_notification-card__C4m4v"};